"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const permission_1 = require("@App/helpers/permission");
const PublisherContactCondensed_1 = __importDefault(require("@App/kit/components/Cards/PublisherContactCondensed"));
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const validate_1 = require("@App/helpers/validate");
const contexts_1 = require("@App/contexts");
class OriginalPublisherCardFull extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "showContactDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "toggleContact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.showContactDetails) {
                    this.setShowContactDetails(false);
                }
                else {
                    this.setShowContactDetails(true);
                }
            }
        });
        Object.defineProperty(this, "setShowContactDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.showContactDetails = value;
            }
        });
        (0, mobx_1.makeObservable)(this, {
            showContactDetails: mobx_1.observable,
            setShowContactDetails: mobx_1.action,
        });
    }
    render() {
        const writers = this.props.data.writers;
        const { data, removeFunc } = this.props;
        const publisherName = data.publisherName;
        const ipiNumber = data.ipiNumber;
        const publisherShare = data.publisherShare;
        const publisherNumber = data.hfaPublisherNumber;
        const classNames = ['original-publisher-card'].join(' ');
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: 'head' },
                react_1.default.createElement("p", { className: `bold ${(0, fields_validators_1.publisherNameInvalidCheck)(publisherName) ? 'red-text' : ''}` }, publisherName ? (0, string_escape_newlines_1.stringEscapeNewlines)(publisherName) : ''),
                react_1.default.createElement("div", { className: 'controls' }, (0, permission_1.canAmend)(data.amend) && removeFunc ? (react_1.default.createElement("span", { className: 'small-2 medium', onClick: () => removeFunc(data) }, "Remove")) : null)),
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement("p", { className: 'small' },
                    react_1.default.createElement("span", { className: `${!(0, validate_1.IPIValidator)(ipiNumber, false) ? 'red-text bold' : ''}` }, "IPI: "),
                    react_1.default.createElement("strong", null, ipiNumber)),
                react_1.default.createElement("p", { className: 'small' },
                    react_1.default.createElement("span", null, "Publisher Number: "),
                    react_1.default.createElement("strong", null, publisherNumber)),
                data.publisherShare !== null && data.publisherShare !== 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: `small ${(0, fields_validators_1.publisherShareInvalidCheck)(publisherShare) ? 'red-text bold' : ''}` }, "Publisher share:"),
                    react_1.default.createElement("h1", { className: 'percent' }, publisherShare ? publisherShare : 0))),
                !!writers.length && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: 'small' }, "Represented Writers:"),
                    react_1.default.createElement("div", { className: 'represented-writers-container' }, writers.map((writer, index) => (react_1.default.createElement("div", { className: 'item', key: index },
                        react_1.default.createElement("p", { className: 'bold small-2' },
                            writer.firstName,
                            " ",
                            writer.lastName)))))))),
            /* data.mailingAddress || data.phone || */ (data.website || data.email) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'contact-details details small bold', onClick: this.toggleContact },
                    "Contact Details ",
                    this.showContactDetails ? '-' : '+'),
                this.showContactDetails && (react_1.default.createElement(PublisherContactCondensed_1.default, { showHfa: data.hfaAgreement, data: data }))))));
    }
}
exports.default = (0, mobx_react_1.observer)(OriginalPublisherCardFull);
OriginalPublisherCardFull.contextType = contexts_1.StoresContext;
